// extracted by mini-css-extract-plugin
export default {"apiKeysTablePlaceholder":"sKJJ-56B0vvxK5k88Na3jqPywIcS4TZpddJkMHH55sw="};